import FormatCurrency from 'components/Common/FormatCurrency'
import LineGuidedtoursIcon from 'components/Luxkit/Icons/line/LineGuidedtoursIcon'
import TextLink from 'components/Luxkit/TextLink'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'
import useTailorMadeTour from 'hooks/TourV2/useTailorMadeTour'
import React from 'react'
import AdditionalWaysToExperienceMessagingTile from './AdditionalWaysToExperienceMessagingTile'
import { getTailorMadeTourRequestFormUrl } from 'lib/tours/tailorMadeTourUtils'

interface Props {
  tourOffer: App.Tours.TourV2Offer
  tourOfferVariation: App.Tours.TourV2OfferVariation
}

function TailorMadeTourMessagingTile({ tourOffer, tourOfferVariation }: Props) {
  const tailorMadeTour = useTailorMadeTour()
  return <AdditionalWaysToExperienceMessagingTile
    heading="Tailor-Made Tour"
    description={<>
      Start crafting a personalised itinerary with our Tours Concierge for a fully refundable{' '}
      {!!tailorMadeTour?.data && <FormatCurrency value={tailorMadeTour.data.fee} />}
      {!tailorMadeTour?.data && <TextLoadingBox width="4ch" />}
      {' '}deposit.
    </>}
    Icon={LineGuidedtoursIcon}
    action={<TextLink size="small" disabled={!tailorMadeTour?.data} to={getTailorMadeTourRequestFormUrl({ tourOffer, tourOfferVariation })}>Submit a request</TextLink>}
  />
}

export default TailorMadeTourMessagingTile
